import { MenuTypes, Tooltip, useShowTooltipOnOverflow } from '@zeptonow/zui';
import Typography from '@zeptonow/zui/Typography';
import { Link, useLocation } from 'react-router-dom';
import { useBreadcrumbStore } from '../../store/useBreadcrumbStore';
import { generateImage } from '../../utils/generateImage';
import { ModuleRoutesInterface } from './types';
import { findNode } from './utils';

const BreadcrumbItems = (
  filteredRoutes: ModuleRoutesInterface[] | undefined,
): JSX.Element[] => {
  const { pathname } = useLocation();
  const breadcrumbDetails = useBreadcrumbStore(
    (state) => state.breadcrumbDetails,
  );
  const { showTooltip } = useShowTooltipOnOverflow();

  const pathnames = pathname.split('/').filter((x: string) => x);

  let currentRoute = '';

  const extraBreadcrumbItems: JSX.Element[] = pathnames.reduce(
    (acc: JSX.Element[], path: string, key: number) => {
      const last = key === pathnames.length - 1;
      currentRoute += `/${path}`;
      const item = findNode(
        'route',
        currentRoute,
        filteredRoutes as MenuTypes[],
      );
      if (item) {
        const itemComponent =
          //TODO: check this item.component clickable
          last || !item.component ? (
            last && breadcrumbDetails ? (
              <Tooltip
                arrow
                title={
                  showTooltip[`breadcrumb-${pathnames.join('-')}`]
                    ? breadcrumbDetails
                    : ''
                }
                open={showTooltip[`breadcrumb-${pathnames.join('-')}`]}
              >
                <div className={'max-w-fit overflow-hidden'}>
                  <Typography
                    key={`${key}-${item?.title}`}
                    className={
                      last
                        ? `px-2 py-1 rounded-md bg-primary-25 text-primary-700 truncate`
                        : ''
                    }
                    id={`breadcrumb-${pathnames.join('-')}`}
                  >
                    {breadcrumbDetails === 'loading'
                      ? 'Loading ...'
                      : breadcrumbDetails}
                  </Typography>
                </div>
              </Tooltip>
            ) : (
              <Typography
                key={`${key}-${item?.title}`}
                className={
                  last
                    ? `px-2 py-1 rounded-md bg-primary-25 text-primary-700`
                    : ''
                }
              >
                {item?.title}
              </Typography>
            )
          ) : (
            <Link
              key={`${key}-${item?.title}`}
              color="inherit"
              to={currentRoute}
              className={`${
                item && typeof item.component !== 'undefined'
                  ? 'cursor-pointer'
                  : 'cursor-default'
              }`}
            >
              {item?.title}
            </Link>
          );
        acc.push(itemComponent);
      }

      return acc;
    },
    [],
  );

  const breadcrumbItems = [
    <Link key="home" color="inherit" to="/">
      {generateImage({
        name: 'home',
        alt: 'home icon',
        className: 'h-4 w-4',
      })}
    </Link>,
  ].concat(extraBreadcrumbItems);

  return breadcrumbItems;
};

export default BreadcrumbItems;
